import RouteBasePaths from 'constants/RouteBasePaths';

export const adminHeaderLinks = [
  {
    label: 'Accounts',
    path: RouteBasePaths.AdminAccountPage
  }
];
